import { type SeasonData } from '#components/FeaturePlayerModal/Tv/types.ts';

export const getNextEpisode = (
  items: SeasonData[],
  [seasonNumber, episodeNumber]: [season: number, episode: number],
): [season: number, episode: number] | undefined => {
  const currentSeason = items.find(item => item.seasonNumber === seasonNumber);

  if (!currentSeason) {
    return undefined;
  }

  const nextEpisode = currentSeason.episodes.find(episode => episode.episodeNumber === episodeNumber + 1);

  if (nextEpisode) {
    return [currentSeason.seasonNumber, nextEpisode.episodeNumber];
  }

  return getNextEpisode(items, [currentSeason.seasonNumber + 1, 0]);
};

export const getPrevEpisode = (
  items: SeasonData[],
  [seasonNumber, episodeNumber]: [season: number, episode?: number],
): [season: number, episode: number] | undefined => {
  const currentSeason = items.find(item => item.seasonNumber === seasonNumber);

  if (!currentSeason) {
    return undefined;
  }

  if (!episodeNumber) {
    // Above condition means .at(-1) will always return an entry
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return [currentSeason.seasonNumber, currentSeason.episodes.at(-1)!.episodeNumber];
  }

  const prevEpisode = currentSeason.episodes.find(episode => episode.episodeNumber === episodeNumber - 1);

  if (prevEpisode) {
    return [currentSeason.seasonNumber, prevEpisode.episodeNumber];
  }

  return getPrevEpisode(items, [currentSeason.seasonNumber - 1]);
};
